var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.isShareable()
  && _vm.shareOpts)?_c('button',{attrs:{"id":"recommend"},on:{"click":function($event){$event.stopPropagation();return _vm.onRecommend($event)}}},[_c('i',{staticClass:"fas fa-share-alt"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }